/* eslint-disable max-classes-per-file */
import { EntitetStatus, KeyValuePair } from "@dffedb/util";

export interface NoteId {
    noteId: number;
    omraadeId: number;
}

export class NoteListeItem {
    public antalBilag: number;
    public dato: Date;
    public fullyLoaded = false;
    public noteId: number;
    public omraadeId: number;
    public overskrift: string;
}

export class Note {
    public bilag: NoteBilag[];
    public dato: Date;
    public fullyLoaded = true;
    public henvendelseTypeId: number;
    public noteId: number;
    public omraadeId: number;
    public opgavestyring: NoteOpgavestyring;
    public overskrift: string;
    public status: EntitetStatus;
    public tekst: string;
    public get antalBilag(): number {
        return this.bilag.length;
    }
}

export class NoteBilag {
    public filNavn: string;
    public filStoerrelseKb: number;
    public noteBilagId: number;
    public status: EntitetStatus;
    public url: string;
}

export interface NoteBilagPDF {
    filNavn: string;
    fil: Blob;
}

export class NoteOpgavestyring {
    public opfoelgAf: string;
    public opfoelgDato: Date;
    public statusId: number;
    public udfoertAf: string;
    public udfoertDato: Date;
}

export type NoteOpgavestyringStatus = KeyValuePair<number, string>;

export type NoteOmraade = KeyValuePair<number, string>;

export class NoteOmraader {
    public static readonly forbruger = 101;
    public static readonly aconto = 102;
    public static readonly installation = 103;
}

export interface NoteHenvendelsestype extends KeyValuePair<number, string> {
    omraadeId: number;
}

export type NoteBruger = KeyValuePair<string, string>;

export function opretTomNote(omraadeId: number): Note {
    const result: Note = {
        get antalBilag(): number {
            return this.bilag.length;
        },
        bilag: [],
        dato: new Date(),
        fullyLoaded: true,
        henvendelseTypeId: 0,
        noteId: 0,
        omraadeId,
        opgavestyring: opretTomOpgavestyring(),
        overskrift: "",
        status: EntitetStatus.Tilfoejet,
        tekst: ""
    };
    return result;
}

export function opretTomOpgavestyring(): NoteOpgavestyring {
    const result: NoteOpgavestyring = {
        opfoelgAf: "",
        opfoelgDato: null,
        statusId: 0,
        udfoertAf: "",
        udfoertDato: null
    };
    return result;
}

export function kopierNote(target: Note, source: Note): void;
export function kopierNote(target: NoteListeItem, source: Note | NoteListeItem): void;

export function kopierNote(target: any, source: any): void {
    const targetErNote = !!target.bilag;

    // Fælles
    target.noteId = source.noteId;
    target.overskrift = source.overskrift;
    target.overskrift = source.overskrift;
    target.dato = source.dato;
    target.omraadeId = source.omraadeId;

    // NoteListeItem
    if (!targetErNote) {
        target.antalBilag = source.antalBilag;
    }

    // Note
    if (targetErNote) {
        target.bilag = source.bilag;
        target.henvendelseTypeId = source.henvendelseTypeId;
        target.tekst = source.tekst;
        target.opgavestyring.opfoelgAf = source.opgavestyring.opfoelgAf;
        target.opgavestyring.opfoelgDato = source.opgavestyring.opfoelgDato;
        target.opgavestyring.statusId = source.opgavestyring.statusId;
        target.opgavestyring.udfoertAf = source.opgavestyring.udfoertAf;
        target.opgavestyring.udfoertDato = source.opgavestyring.udfoertDato;
    }
}
